export default {
    // vacancyEvictionBalance导出csv
    vacancyEvictionBalanceExportCSV: "/report/vacancyEvictionBalance/export/csv",
    // vacancyEvictionBalance导出pdf
    vacancyEvictionBalanceExportPDF: "/report/vacancyEvictionBalance/export/pdf",
    // vacancyEvictionBalance查询
    vacancyEvictionBalanceShow: "/report/vacancyEvictionBalance/show",
    // evictionStatus下拉框
    vacancyEvictionBalanceEvictionStatus: "/report/vacancyEvictionBalance/evictionStatus",
    // vacantUnitStatus下拉框
    vacancyEvictionBalanceVacantUnitStatus: "/report/vacancyEvictionBalance/vacantUnitStatus",
}